import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMediaQueryMatchesOnMobile } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { Box, Group, GroupAlign, GroupGutter, Text, TextType, Heading, HeadingSize } from '@as/cotopaxi';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { ButtonAlpha } from '@yonderland/andes-react';
export const ProductWizardIntro = ({ loggedIn, userFirstName, title, subTitle, buttonLabel, startProductWizard, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const isMobile = useMediaQueryMatchesOnMobile();
    const headingSize = isMobile ? HeadingSize.XS : HeadingSize.L;
    return (_jsxs(Box, { mobile: {
            spacing: {
                paddingTop: 1,
                paddingLeft: 2,
                paddingRight: 2,
                paddingBottom: 2,
            },
        }, tablet: {
            spacing: {
                paddingTop: 0,
                paddingLeft: 4,
                paddingRight: 4,
                paddingBottom: 4,
            },
        }, children: [_jsxs(Box, { mobile: { spacing: { marginBottom: 5 } }, tablet: { spacing: { marginBottom: 9 } }, children: [_jsx(Heading, { size: headingSize, children: `${t('productWizard.greeting')}${loggedIn ? ` ${userFirstName}` : ''}!` }), _jsx(Heading, { size: headingSize, children: title }), subTitle && (_jsx(Box, { mobile: { spacing: { marginTop: 1 } }, tablet: { spacing: { marginTop: 2 } }, children: _jsx(Text, { type: TextType.CONTENT, children: subTitle }) }))] }), _jsx(Group, { align: GroupAlign.SPACE_AROUND, gutter: GroupGutter.NONE, children: _jsx(ButtonAlpha, { noBubble: true, fullWidth: isMobile, theme: "branded", text: buttonLabel, onClick: startProductWizard }) })] }));
};
